var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.mode == "edit"
        ? _c(
            "el-select",
            {
              staticClass: "wp-10",
              attrs: {
                placeholder: _vm.placeholder,
                value: _vm.value,
                filterable: _vm.filterable,
                disabled: _vm.disabled,
                "data-bot": _vm.dataBot,
                "popper-append-to-body": _vm.appendToBody,
                "popper-class": "custom-dropdown"
              },
              on: { change: _vm.update }
            },
            [
              _vm.selectNothing
                ? _c("el-option", {
                    attrs: { label: _vm.selectNothing, value: null }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.options, function(option) {
                return _c(
                  "el-option",
                  {
                    key: option[_vm.idColumn],
                    attrs: {
                      label: option[_vm.labelColumn],
                      value: option[_vm.idColumn],
                      disabled: !!option.disabled
                    }
                  },
                  [
                    _vm._t(
                      "default",
                      [_vm._v(_vm._s(option[_vm.labelColumn]))],
                      { option: option }
                    )
                  ],
                  2
                )
              })
            ],
            2
          )
        : _c("p", [
            _vm._v("\n        " + _vm._s(_vm.labelFromValue) + "\n    ")
          ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }